import styled, { css } from 'styled-components';
import { Typography } from '@mui/material';
import type { PlanApprovalStatus } from '../../../types';
import { Flex, FlexColumn } from '../../Flex';

type StatusProps = { $status?: PlanApprovalStatus };

const statusBorder = css<StatusProps>`
  ${({ $status, theme }) =>
    $status === 'confirmed' &&
    css`
      border-color: ${theme.palette.common.green100};
    `}

  ${({ $status, theme }) =>
    $status === 'rejected' &&
    css`
      border-color: ${theme.palette.common.red100};
    `}
`;

const statusBackground = css<StatusProps>`
  ${({ $status, theme }) =>
    $status === 'confirmed' &&
    css`
      background: ${theme.palette.common.green10};
    `}

  ${({ $status, theme }) =>
    $status === 'rejected' &&
    css`
      background: ${theme.palette.common.red10};
    `}
`;

const headerLayout = css<StatusProps>`
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background: ${({ theme }) => theme.palette.common.gray9};
  ${statusBackground}
`;

export const ApprovalCard = styled(FlexColumn)<StatusProps>`
  max-width: 100%;
  border: 1px solid ${({ theme }) => theme.palette.common.gray17};
  border-radius: 8px;
  overflow: hidden;
  ${statusBorder}
`;

export const ApprovalCardHeader = styled(Flex)<StatusProps>`
  ${headerLayout}
`;

export const ApprovalCardHeaderButton = styled.button.attrs({
  type: 'button',
})<StatusProps>`
  display: flex;
  justify-content: space-between;
  width: 100%;
  border: none;
  cursor: pointer;
  font: inherit;
  text-align: left;
  ${headerLayout}
`;

export const ApprovalCardTitle = styled(Typography).attrs({
  component: 'span',
})<StatusProps>`
  font-size: 13px;
  font-weight: 600;

  ${({ $status, theme }) =>
    $status === 'confirmed' &&
    css`
      color: ${theme.palette.common.green100};
    `}

  ${({ $status, theme }) =>
    $status === 'rejected' &&
    css`
      color: ${theme.palette.common.red100};
    `}
`;

export const ApprovalCardBody = styled(FlexColumn)`
  padding: 12px 14px;
  gap: 16px;
`;
